import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ColDef } from 'ag-grid-community';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { dateValueFormatter } from '@mysrc/app/shared/utils/date-formatter';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef, ViewChild } from '@angular/core';
import { SectionService } from '../../services/sectionservice';
import { CommonService } from '../../../question/services/commonservice';
//import { SettingService } from '../../../setting/services/settingservice';


 



@Component({
  selector: 'section',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    IsgGridComponent
  ],
  templateUrl: './page-survey-section.component.html',
  styleUrl: './page-survey-section.component.scss',
  providers: [CommonService, SectionService, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageSurveySectionComponent extends BaseHttpReqRespService {

  @ViewChild('sectionModal') sectionModal!: TemplateRef<any>;
  @ViewChild('deleteSectionModal') deleteSectionModal!: TemplateRef<any>;
  modalRef: NgbModalRef | undefined;

  gridConfig: Partial<IsgGridConfig> = {
    height: '500px',
    pagination: true,
    pageSize: 10,
    rowSelection: 'single',
    autoSizeColumns: true
  };


  SECTION_ENDPOINT = API_ENDPOINTS.SECTION;
  myAppUrl: any;
  public sectionnewlist!: Section[];
  sectionForm!: FormGroup;
  successOrFailureMessage: string = '';
  currentDeletingSectionId!: number;
  isAgreeDisagreedisabled: boolean = false;
  isLoading = false;

  constructor(
     http: HttpClient,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private EncrDecr: EncrDecrService,
    private sectionService: SectionService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private _router: Router,
    private modalService: NgbModal,
    @Inject('BASE_URL') baseUrl: string
  ) {
    console.log('constructor loded');
    super(http, oauth);
    this.myAppUrl = baseUrl;
  }

  ngOnInit() {
    console.log('ngOnInit loded');
    this.initForm();
    this.getSectionList();
    //this.getSectionDetails(0);
  }

//  noWhitespaceValidator(control: FormControl) {
//  const isWhitespace = (control.value || '').trim().length === 0;
//  const isValid = !isWhitespace;
//  return isValid ? null : { 'whitespace': true };
  //}

  initForm() {
    this.sectionForm = this.formBuilder.group({
      sectionId: 0,
      sectionName: ['', Validators.required],
      sectionDescription: ['', [Validators.required, this.kendoEditorRequired]],
      confirmation: [null],
      isAgree: [null],
      isDisagree: [null],
      AcceptedText: ['', Validators.required],
      NotAcceptedText: ['', Validators.required],
      //AcceptedText: [''],
      //NotAcceptedText: [''],
    });
  }

 kendoEditorRequired(control: FormControl) {
  const value = (control.value || '').replace(/<[^>]*>/g, '').trim();
  return value.length > 0 ? null : { required: true };
}

  getSectionList() {
    //this.isLoading = true;
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    this.sectionService.getSectionList(workspaceId).subscribe({
      next: (result: any[]) => {
        this.sectionnewlist = result;
        //this.isLoading = false;
      },
      error: (error) => {
        console.error(error);
        //this.isLoading = false;
      }
    });
  }

  getSectionDetails(sectionId: number) {
    this.sectionService.getSectionDetails(sectionId).subscribe({
      next: (response) => {
        this.isAgreeDisagreedisabled = !!response.confirmation;
        this.sectionForm.patchValue({
          sectionName: response.sectionName,
          sectionId: response.sectionId,
          sectionDescription: response.sectionDescription,
          confirmation: response.confirmation,
          AcceptedText: response.acceptedText,
          NotAcceptedText: response.notAcceptedText
        });
      },
      error: (error) => console.error(error)
    });
  }

  toggleRadio(option: 'isAgree' | 'isDisagree') {
    const currentValue = this.sectionForm.get('isAgree')?.value;
    if (option === 'isAgree') {
      // If already selected, unselect
      this.sectionForm.get('isAgree')?.setValue(currentValue === true ? null : true);
    } else {
      // If already selected, unselect
      this.sectionForm.get('isAgree')?.setValue(currentValue === false ? null : false);
    }
  }

  openAddSectionModal(content: any): void {
    this.sectionForm.reset();
    this.isAgreeDisagreedisabled = false;
    this.modalRef = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      modalDialogClass: 'modal-primary'
    });
  }

  openDeleteSectionModal(): void {
    this.modalRef = this.modalService.open(this.deleteSectionModal, {
      backdrop: 'static',
      keyboard: false
    });
  }

  onClose() {
    this.sectionForm.reset();
  }

  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }

  saveSection() {
    debugger;
    const userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    this.sectionService.saveSection(this.sectionForm.value, userId, workspaceId).subscribe({
      next: (result) => {
        this.sectionnewlist = result;
        this.successOrFailureMessage = "Informational section has been created successfully.";
        this.messageTimeout();
        this.sectionForm.reset();
      },
      error: (error) => console.error(error)
    });
  }

  deleteSection() {
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    this.sectionService.deleteSection(this.currentDeletingSectionId.toString(), workspaceId).subscribe({
      next: (result) => {
        if (result.length > 0) {
          this.sectionnewlist = result;
          this.successOrFailureMessage = "Informational section has been deleted successfully from the repository.";
        } else {
          this.successOrFailureMessage = "This section cannot be deleted because it is still referenced in survey settings.";
        }
        this.messageTimeout();
      },
      error: (error) => console.error(error)
    });
  }

  messageTimeout() {
    window.setTimeout(() => {
      this.successOrFailureMessage = '';
    }, 1500);
  }

  //change(event: any) {
  //  this.isAgreeDisagreedisabled = event.target.checked;
  //}

  change(event: Event): void {
    this.isAgreeDisagreedisabled = (event.target as HTMLInputElement).checked;

    const acceptedTextControl = this.sectionForm.get('AcceptedText');
    const notAcceptedTextControl = this.sectionForm.get('NotAcceptedText');

    if (this.isAgreeDisagreedisabled) {
      // Set default values if empty
      if (!acceptedTextControl?.value || acceptedTextControl.value.trim() === '') {
        acceptedTextControl?.setValue('Agree');
      }
      if (!notAcceptedTextControl?.value || notAcceptedTextControl.value.trim() === '') {
        notAcceptedTextControl?.setValue('Disagree');
      }
      // Make required
      acceptedTextControl?.setValidators([Validators.required]);
      notAcceptedTextControl?.setValidators([Validators.required]);
    } else {
      // Remove required
      acceptedTextControl?.clearValidators();
      notAcceptedTextControl?.clearValidators();
    }

    acceptedTextControl?.updateValueAndValidity();
    notAcceptedTextControl?.updateValueAndValidity();

    if (!this.isAgreeDisagreedisabled) {
      // Unselect both radio buttons by setting isAgree to null
      this.sectionForm.get('isAgree')?.setValue(null);
    }
  }

  linkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const text = this.renderer.createText(params.value);
    this.renderer.appendChild(element, text);
    element.setAttribute('href', 'javascript:void(0)');
    element.setAttribute('class', 'anchor-cursor');
    this.renderer.listen(element, 'click', () => {
      // Find the section in the local list
      const section = this.sectionnewlist.find(s => s.sectionId === params.data.sectionId);
      if (section) {
        this.isAgreeDisagreedisabled = !!section.confirmation;
        this.sectionForm.patchValue({
          sectionName: section.sectionName,
          sectionId: section.sectionId,
          sectionDescription: section.sectionDescription,
          confirmation: section.confirmation,
          AcceptedText: section.AcceptedText,
          NotAcceptedText: section.NotAcceptedText
        });
        this.modalRef = this.modalService.open(this.sectionModal, {
          backdrop: 'static',
          keyboard: false,
          size: 'lg',
          modalDialogClass: 'modal-primary'
        });
      }
      return true;
    });
    return element;
  }

  //linkRenderer(params: any) {
  //  const element = this.renderer.createElement('a');
  //  const text = this.renderer.createText(params.value);
  //  this.renderer.appendChild(element, text);
  //  element.setAttribute('href', 'javascript:void(0)');
  //  element.setAttribute('class', 'anchor-cursor');
  //  this.renderer.listen(element, 'click', () => {
  //    // Fetch section details and open modal after data is loaded
  //    this.getSectionDetailsAndOpenModal(params.data.sectionId);
  //    return true;
  //  });
  //  return element;
  //}

  //getSectionDetailsAndOpenModal(sectionId: number) {
  //  this.sectionService.getSectionDetails(sectionId).subscribe({
  //    next: (response) => {
  //      this.isAgreeDisagreedisabled = !!response.confirmation;
  //      this.sectionForm.patchValue({
  //        sectionName: response.sectionName,
  //        sectionId: response.sectionId,
  //        sectionDescription: response.sectionDescription,
  //        confirmation: response.confirmation,
  //        AcceptedText: response.acceptedText,
  //        NotAcceptedText: response.notAcceptedText
  //      });
  //      // Open the modal after data is patched
  //      this.modalRef = this.modalService.open(this.sectionModal, {
  //        backdrop: 'static',
  //        keyboard: false,
  //        size: 'lg',
  //        modalDialogClass: 'modal-primary'
  //      });
  //    },
  //    error: (error) => console.error(error)
  //  });
  //}

  deleteImageRenderer(params: any) {
    //debugger;
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.listen(element, 'click', () => {
      this.currentDeletingSectionId = params.data.sectionId;
      this.openDeleteSectionModal();
    });
    return element;
  }

  SurveySectionSettingsRenderer(params: any) {
    const langSettingsAnchor = this.renderer.createElement('a');
    const langSettingsIcon = this.renderer.createElement('i');
    langSettingsIcon.setAttribute('class', 'fa fa-cogs anchor-cursor p-2');
    langSettingsIcon.setAttribute('title', 'Language Settings');
    this.renderer.appendChild(langSettingsAnchor, langSettingsIcon);
    const sectionReference = params.data.sectionId;
    this.renderer.listen(langSettingsAnchor, 'click', () => {
      this._router.navigate(['surveysectionlanguagesettings'], { queryParams: { sectionId: sectionReference } });
    });
    return langSettingsAnchor;
  }

  columnDefs: ColDef<Section, any>[] = [
    { headerName: 'Section ID', field: 'sectionId', hide: true, filter: true },
    { headerName: 'Section Name', field: 'sectionName', cellRenderer: this.linkRenderer.bind(this), resizable: true, filter: true },
    { headerName: 'Created By', field: 'createdBy' as keyof Section, resizable: true, filter: true },
    { headerName: 'Modified By', field: 'modifiedBy' as keyof Section, resizable: true, filter: true },
    { headerName: 'Created Date', field: 'createdDate' as keyof Section, width: 120, resizable: true, filter: true, valueFormatter: dateValueFormatter },
    { headerName: 'Modified Date', field: 'modifiedDate' as keyof Section, width: 120, resizable: true, filter: true, valueFormatter: dateValueFormatter },
    { headerName: 'Settings', cellRenderer: this.SurveySectionSettingsRenderer.bind(this), resizable: true },
    { headerName: 'Delete', cellRenderer: this.deleteImageRenderer.bind(this), resizable: true },
  ];
}

interface Section {
  sectionName: string;
  sectionId: number;
  sectionDescription: string;
  confirmation: boolean;
  AcceptedText: string;
  NotAcceptedText: string;
  isAgree: boolean;
  isDisagree: boolean;
  createdBy?: string;
  modifiedBy?: string;
  createdDate?: string;
  modifiedDate?: string;
}
